import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { blockRoute } from '@app/store/catalogue/thunks';
import {
  clearExpandedElements,
  addExpandedElement,
} from '@app/store/catalogue/actions';
import { AppState } from '@app/store';
import ServiceItem from '@app/components/ServiceItem/ServiceItem';
import SubService from '@app/components/SubService/SubService';
import cn from 'classnames';
import './style.scss';
import { ServiceGroupItemProps } from './ServiceGroupItemProps';
import { MetricParam, useSpatz } from '@app/hooks/useSpatz';

const ServiceGroupItem: React.FC<ServiceGroupItemProps> = ({
  className,
  group,
  blockRoute,
  expandedElements,
  addExpandedElement,
  clearExpandedElements,
}) => {
  const { sendSpatzStats } = useSpatz({
    Services: { catalog: { Главная: {} } },
  });

  const clickHandler = () => {
    blockRoute();
    clearExpandedElements();
    if (!expandedElements.includes(group.id)) {
      const data: MetricParam = {
        'клик на группу услуг': { click: group.title },
      };
      sendSpatzStats(data);
      addExpandedElement(group.id);
    }
  };

  return (
    <div
      className={cn(className, 'mos-catalog-service-group', {
        'mos-catalog-service-group__opened': expandedElements.includes(
          group.id
        ),
      })}
    >
      <Link
        className="mos-catalog-service-group__link"
        to={
          expandedElements.includes(group.id)
            ? group.openedRoutePath
            : group.routePath
        }
        onClick={clickHandler}
        role="button"
        aria-label={`Группа услуг ${group.title}`}
        aria-expanded={expandedElements.includes(group.id) ? 'true' : 'false'}
      >
        {group.marks &&
          group.marks.map((mark) => (
            <div
              key={mark.id}
              className={`mos-catalog-service-group_label mos-catalog-service-group_label-${mark.code}`}
            >
              {mark.title}
            </div>
          ))}
        <div className="mos-catalog-service-group__title">{group.title}</div>
      </Link>
      {expandedElements.includes(group.id) && (
        <div className="mos-catalog-service-group__services">
          {group.children &&
            group.children.map((service) => {
              if (service.subServices && service.subServices.length > 0) {
                return (
                  <SubService
                    key={service.id}
                    service={service}
                    isActive={expandedElements.includes(service.id!)}
                    handleClick={() => {
                      clearExpandedElements();
                      addExpandedElement(group.id);
                      if (!expandedElements.includes(service.id!)) {
                        addExpandedElement(service.id);
                      }
                    }}
                  />
                );
              } else {
                return <ServiceItem key={service.id} service={service} />;
              }
            })}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  expandedElements: state.catalogue.expandedElements,
});

const dispatchProps = {
  blockRoute,
  addExpandedElement,
  clearExpandedElements,
};

const ConnectedServiceGroupItem = connect(
  mapStateToProps,
  dispatchProps
)(ServiceGroupItem);

export default ConnectedServiceGroupItem;
